module.exports = __webpack_public_path__ + "img/service.5718c69e.png";